import { Component, inject, Input } from '@angular/core';
import { NotificationKeyEnum, NotificationViewDto } from '../../../../models/notification-view-dto';
import { NotificationService } from '../../../../services/notification.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { PATHS } from '../../../../models/bary-paths.model';
import { Pagination } from '../../../../models/pagination.model';
import { CurrentDataService } from '../../../../services/current-data-service';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  styleUrls: ['./bary-notification.component.scss'],
  selector: 'jhi-bary-notification',
  templateUrl: './bary-notification.component.html',
  animations: [
    // the fade-in/fade-out animation.
    trigger('animationWhenDeleteNotification', [
      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [style({ opacity: 0 }), animate(200)]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave', animate(400, style({ opacity: 0 }))),
    ]),
  ],
})
export class BaryNotificationComponent {
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);
  private readonly currentDataService = inject(CurrentDataService);

  @Input() notifications: NotificationViewDto[] = [];
  @Input() pagination: Pagination = new Pagination();

  protected readonly FAS = FaDirectiveEnum.FAS;

  public remove(event: any, notif: NotificationViewDto): void {
    event.preventDefault();
    // Stop the event propagation to prevent the dropdown from closing
    event.stopImmediatePropagation();
    this.notificationService.closedById(notif.id).subscribe({
      next: () => {
        this.notificationService.getCurrentNotifications().subscribe((res: { content: NotificationViewDto[]; pagination: Pagination }) => {
          this.currentDataService.updateCurrentNotifications(res);
        });
      },
    });
  }

  public getRedirect(notif: NotificationViewDto): void {
    switch (notif.key) {
      case NotificationKeyEnum.NEW_BILL_GENERATE:
      case NotificationKeyEnum.BILL_STATUS_CHANGE_PAYED:
      case NotificationKeyEnum.BILL_STATUS_CHANGE_ISSUED:
        // si je suis moderateur alors je suis rediriger sur MIDDLE / BILLS
        // si je suis customer je suis rediriger sur MY-BILLS
        // this.router.navigateByUrl(PATHS.MIDDLE_BILLS_BILLS.path);
        break;
      case NotificationKeyEnum.TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE:
        break;
      case NotificationKeyEnum.TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE_DELIVERED:
        break;
      case NotificationKeyEnum.TRANSPORT_ORDER_DELIVERY_STATUS_CHANGE_ISSUED:
        break;
      case NotificationKeyEnum.QUOTATION_NEW:
        // moderator
        this.router.navigateByUrl(PATHS.MIDDLE_QUOTATIONS_NEW.path);
        break;
      case NotificationKeyEnum.QUOTATION_TRANSPORTER_ACCEPTED:
        // customer
        this.router.navigateByUrl(PATHS.USER_MY_QUOTATION_ONGOING.path);
        break;
      case NotificationKeyEnum.QUOTATION_TRANSPORTER_REJECTED:
        this.router.navigateByUrl(PATHS.USER_MY_QUOTATION_OLD.path);
        break;
      case NotificationKeyEnum.QUOTATION_TRANSPORTER_EXPIRED_PICKUP_DATE:
        // IF moderator / customer
        // this.router.navigateByUrl(PATHS.USER_MY_QUOTATION_OLD.path);
        break;
      case NotificationKeyEnum.QUOTATION_CUSTOMER_ACCEPTED:
        // moderator
        this.router.navigateByUrl(PATHS.MIDDLE_QUOTATIONS_OLD.path);
        break;
      case NotificationKeyEnum.QUOTATION_CUSTOMER_REJECTED:
        // moderator
        this.router.navigateByUrl(PATHS.MIDDLE_QUOTATIONS_OLD.path);
        break;
      case NotificationKeyEnum.QUOTATION_CUSTOMER_EXPIRED_VALIDITY_DATE:
        // this.router.navigateByUrl(PATHS.MIDDLE_QUOTATIONS_OLD.path);
        break;
      case NotificationKeyEnum.QUOTATION_CUSTOMER_EXPIRED_PICKUP_DATE:
        // this.router.navigateByUrl(PATHS.MIDDLE_QUOTATIONS_OLD.path);
        break;
      case NotificationKeyEnum.QUOTATION_CUSTOMER_ACCEPTED_BUT_EXPIRED_VALIDITY_DATE:
        // this.router.navigateByUrl(PATHS.MIDDLE_QUOTATIONS_OLD.path);
        break;
      case NotificationKeyEnum.QUOTATION_CUSTOMER_ACCEPTED_BUT_EXPIRED_PICKUP_DATE:
        // this.router.navigateByUrl(PATHS.MIDDLE_QUOTATIONS_OLD.path);
        break;
      case NotificationKeyEnum.BILL_PAYMENT_LATE:
        break;
      case NotificationKeyEnum.BILL_PAYMENT_LATE_RELAUNCH_1:
        break;
      case NotificationKeyEnum.BILL_PAYMENT_LATE_RELAUNCH_2:
        break;
      case NotificationKeyEnum.BILL_PAYMENT_LATE_RELAUNCH_3:
        break;
      case NotificationKeyEnum.BASKET_NOT_PAID:
        break;
      case NotificationKeyEnum.PRICING_IMPORTED_FOR_CUSTOMER:
      case NotificationKeyEnum.PRICING_NOT_IMPORTED_FOR_CUSTOMER:
        this.router.navigateByUrl(PATHS.MIDDLE_CUSTOMER_ID_PRICING.withId(Number(notif.messageParams['CustomerId'])));
        break;
    }
  }
}
